.verticalMenu {
  --pgm-vertical-menu-width: 240px;
  --md-menu-container-color: var(--pgm-sys-color-surface-container-low);
  --md-menu-container-shape: 16px;
  --md-menu-top-space: 4px;
  --md-menu-bottom-space: 4px;

  max-width: var(--pgm-vertical-menu-width);
  min-width: var(--pgm-vertical-menu-width);
  width: var(--pgm-vertical-menu-width);
}
